import type { ReactNode } from "react";

import styles from "./styles.module.css";

interface DocumentCalloutProps {
  source: string;
  title: string;
  children: ReactNode;
}

export function DocumentCallout({ source, title, children }: DocumentCalloutProps) {
  return (
    <aside className={styles.callout} data-reveal>
      <span className={styles.source}>{source}</span>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.body}>{children}</div>
    </aside>
  );
}

export default DocumentCallout;
